<template>
  <div class="select-custom">
    <div class="select-custom__label">
      {{ label }}
    </div>

    <select class="select-custom__select" :value="value" @input="selectChange">
      <option v-for="item in options" :key="item.value" :value="item.value">
        {{ item.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectCustom',

  props: {
    label: String,
    options: Array,
    value: String
  },

  methods: {
    selectChange (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-custom {
  position: relative;
  display: inline-block;
  padding: 0 30px 0 20px;
  border-radius: 1em;
  transition: background-color 0.1s;
  background: {
    color: nth($color-custom, 1);
    image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IlNvbGlkIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZmlsbD0iI0ZGRkZGRiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAgICAiIGQ9Ik00MDAsMjE2Yy02LjQsMC0xMi41LTIuNS0xNy03TDI1Niw4MkwxMjksMjA5CgljLTkuNCw5LjQtMjQuNiw5LjQtMzMuOSwwcy05LjQtMjQuNiwwLTMzLjlMMjM5LDMxYzkuNC05LjQsMjQuNi05LjQsMzMuOSwwbDAsMGwxNDQsMTQ0YzkuNCw5LjQsOS40LDI0LjYsMCwzMy45CglDNDEyLjUsMjEzLjUsNDA2LjQsMjE2LDQwMCwyMTZ6IE0yNzMsNDgxbDE0NC0xNDRjOS40LTkuNCw5LjQtMjQuNiwwLTMzLjlzLTI0LjYtOS40LTMzLjksMGwtMTI3LDEyN0wxMjksMzAzCgljLTkuNC05LjQtMjQuNi05LjQtMzMuOSwwcy05LjQsMjQuNiwwLDMzLjlsMTQ0LDE0NEMyNDguNCw0OTAuMywyNjMuNiw0OTAuMywyNzMsNDgxTDI3Myw0ODF6Ii8+Cjwvc3ZnPgo=');
    position: calc(100% - 10px) 50%;
    repeat: no-repeat;
    size: 12px auto;
  }
  text-align: center;

  &__label {
    color: #fff;
    font-size: 0.8rem;
    line-height: 43px;
    text-transform: uppercase;
  }

  &__select {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    min-width: 100%;
    height: 100%;
    opacity: 0;
    appearance: none;
    cursor: pointer;
  }
}
</style>
